exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-37ef0cc6]{margin-bottom:.3rem}.msg-company[data-v-37ef0cc6]{font-size:1.5rem;display:inline-flex;margin-bottom:15px}@media (max-width:991px){.msg-company[data-v-37ef0cc6],.page-contact-desc[data-v-37ef0cc6]{max-width:100%!important}}", ""]);

// exports
